import { Intent } from './constants.js';

const modifiers = ['accessibly-hidden', 'active', 'fill', 'interactive', 'inverted', 'large', 'round', 'small', 'vertical'];
const intentMap = {
  error: Intent.DANGER
};
const buildModifierClassNames = () => modifiers.reduce((acc, modifier) => {
  acc[modifier.toUpperCase().replace('-', '_')] = `nui-${modifier}`;
  return acc;
}, {});
function getIntentClass(intent) {
  if (intent == null || intent === Intent.NONE) {
    return undefined;
  }
  return `nui-intent-${(intentMap[intent] ?? intent).toLowerCase()}`;
}
const CommonClasses = {
  ...buildModifierClassNames()
};

export { CommonClasses, getIntentClass };
